import '../../style/index.less';
import './index.less';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/empty/style/index.js
// module id = 97
// module chunks = 0